module.exports = __webpack_public_path__ + "static/img/lgchem.f6b72f9.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project/lgchem.jpg
// module id = yJPw
// module chunks = 0